import React, { Component } from 'react';
import styled from 'styled-components';
import HistoryComponent from './History';
import SettingComponent from './Setting';

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 30px;
`;
const Logo = styled.img`
  width: 30%;
  transition: 100ms;
  &:active {
    transform: scale(0.85);
  }
`;

class TopMenuComponent extends Component {
  render() {
    return (
      <Container>
        <HistoryComponent />
        <Logo src="/assets/LogoWhite.png" alt="logo" onClick={()=>window.open("https://xitonix.com")} />
        <SettingComponent/>
      </Container>
    );
  }
}

export default TopMenuComponent;